import { array as codecArray } from 'purify-ts/Codec';
import { makeResponses } from '../response_factory';
import { utils as coreUtils, paginated, requestParams } from '@codegrade/api-core';
import { Assignment, BulkEnrollCourseData, ChangeUserRoleCourseData, Course, CourseAuthorization, CourseBulkEnrollResult, CourseEnrollment, CoursePrice, CourseRegistrationLink, CourseRole, CourseSection, CourseSnippet, CourseStatisticsAsJSON, CreateAssignmentCourseData, CreateCourseData, CreateGroupSetCourseData, CreateRoleCourseData, CreateSectionCourseData, CreateSnippetCourseData, EmailUsersCourseData, ExtendedAssignment, ExtendedCourse, ExtendedCourseRegistrationLink, ExtendedCourseRole, GroupSet, ImportIntoCourseData, ImportSnippetsIntoCourseData, Job, PatchCourseData, PatchRoleCourseData, PatchSnippetCourseData, PutEnrollLinkCourseData, PutPriceCourseData, RegisterUserWithLinkCourseData, UserLoginResponse, Work, } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function course(config) {
    const createResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(ExtendedCourse)),
    });
    const getAllResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(Course))),
    });
    const createRoleResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(ExtendedCourseRole)),
    });
    const getCourseRolesResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(CourseRole))),
    });
    const bulkEnrollResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(CourseBulkEnrollResult)),
    });
    const createSnippetResponse = /* #__PURE__ */ makeResponses({
        201: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(CourseSnippet)),
    });
    const createGroupSetResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(GroupSet)),
    });
    const getGroupSetsResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(GroupSet))),
    });
    const createAssignmentResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(ExtendedAssignment)),
    });
    const getAssignmentsResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(Assignment))),
    });
    const putEnrollLinkResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(CourseRegistrationLink)),
    });
    const getAllEnrollLinksResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(CourseRegistrationLink))),
    });
    const createSectionResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(CourseSection)),
    });
    const getSectionsResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(CourseSection))),
    });
    const deletePriceResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const putPriceResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(CoursePrice)),
    });
    const deleteSnippetResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const patchSnippetResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const deleteEnrollLinkResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const getRegistrationLinkResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(
        /* #__PURE__ */ parseJsonResponse(ExtendedCourseRegistrationLink)),
    });
    const deleteRoleResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const getCourseRoleResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(ExtendedCourseRole)),
    });
    const patchRoleResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(ExtendedCourseRole)),
    });
    const deleteUserResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const getAllUsersResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(CourseEnrollment))),
    });
    const changeUserRoleResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(CourseEnrollment)),
    });
    const getResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(ExtendedCourse)),
    });
    const patchResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(ExtendedCourse)),
    });
    const getSnippetsResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(CourseSnippet))),
    });
    const getStatisticsResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(CourseStatisticsAsJSON)),
    });
    const getAuthorizationResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(CourseAuthorization)),
    });
    const getSubmissionsByUserResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(Work))),
    });
    const importIntoResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(ExtendedCourse)),
    });
    const importSnippetsIntoResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const joinAsLoggedInUserResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const registerUserWithLinkResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(UserLoginResponse)),
    });
    const emailUsersResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(Job)),
    });
    return Object.freeze({
        /**
         * Create a new course.
         *
         * @param arg The arguments to the function.
         * @param arg.requestBody The body of the request.
         * @returns A response containing the JSON serialization of the new course
         */
        create: async ({ requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/courses/`, createResponse.v, JSON.stringify(CreateCourseData.encode(requestBody)));
            return result;
        },
        /**
         * Return all Course objects the current user is a member of.
         *
         * @param arg The arguments to the function.
         * @param arg.ltiCourseId The id of the course according to the lti platform.
         * @param arg.tenantId The id of the tenant to which you want to limit the courses you are searching.
         * @param arg.q Only find courses matching this search query, currently only searches for course names in a fuzzy way.
         * @param arg.pageSize The size of a single page, maximum is 50.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns A response containing the requested courses.
         */
        getAll: async ({ ltiCourseId = undefined, tenantId = undefined, q = undefined, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/courses/`, getAllResponse.v, undefined, {
                lti_course_id: ltiCourseId,
                tenant_id: tenantId,
                q,
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Add a new `CourseRole` to the given `Course`.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course
         * @param arg.requestBody The body of the request.
         * @returns An empty response with return code 204.
         */
        createRole: async ({ courseId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/courses/${courseId}/roles/`, createRoleResponse.v, JSON.stringify(CreateRoleCourseData.encode(requestBody)));
            return result;
        },
        /**
         * Get a list of all course roles in a given course.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course to get the roles for.
         * @param arg.q Search on the name for the roles.
         * @param arg.pageSize The size of a single page, maximum is 50.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns An array of all course roles for the given course.
         */
        getCourseRoles: async ({ courseId, q = undefined, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/courses/${courseId}/roles/`, getCourseRolesResponse.v, undefined, {
                q,
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Bulk enroll users into this course.
         *
         * All given users are directly enrolled into the course, and they will receive an email confirming that they have been enrolled.
         *
         * Users that do not exist yet are created, but no password is set yet so they cannot log in. Their course enrollment email will include a link to a page where they can set their password.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course in which users should be enrolled.
         * @param arg.requestBody The body of the request.
         * @returns A dictionary containing the job sending out the mails, a list of newly created users, and a list of users that could not be created because of SSO incompatibility.
         */
        bulkEnroll: async ({ courseId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/courses/${courseId}/bulk_enroll/`, bulkEnrollResponse.v, JSON.stringify(BulkEnrollCourseData.encode(requestBody)));
            return result;
        },
        /**
         * Add or modify a `CourseSnippet` by key.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course in which you want to create a new snippet.
         * @param arg.requestBody The body of the request.
         * @returns A response containing the JSON serialized snippet and return code 201.
         */
        createSnippet: async ({ courseId, requestBody, }) => {
            const result = await requestParams(config, 'PUT', `/api/v1/courses/${courseId}/snippet`, createSnippetResponse.v, JSON.stringify(CreateSnippetCourseData.encode(requestBody)));
            return result;
        },
        /**
         * Create or update a `GroupSet` in the given course id.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course in which the group set should be created or updated. The course id of a group set cannot change.
         * @param arg.requestBody The body of the request.
         * @returns The created or updated group.
         */
        createGroupSet: async ({ courseId, requestBody, }) => {
            const result = await requestParams(config, 'PUT', `/api/v1/courses/${courseId}/group_sets/`, createGroupSetResponse.v, JSON.stringify(CreateGroupSetCourseData.encode(requestBody)));
            return result;
        },
        /**
         * Get the all the group sets of a given course.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course of which the group sets should be retrieved.
         * @param arg.pageSize The size of a single page, maximum is 50.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns A list of group sets.
         */
        getGroupSets: async ({ courseId, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/courses/${courseId}/group_sets/`, getGroupSetsResponse.v, undefined, {
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Create a new course for the given assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The course to create an assignment in.
         * @param arg.requestBody The body of the request.
         * @returns The newly created assignment.
         */
        createAssignment: async ({ courseId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/courses/${courseId}/assignments/`, createAssignmentResponse.v, JSON.stringify(CreateAssignmentCourseData.encode(requestBody)));
            return result;
        },
        /**
         * Get all assignments of the given course.
         *
         * The returned assignments are sorted by deadline.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course
         * @param arg.hasRubric Get only assignments that have a rubric.
         * @param arg.hasAutoTest Get only assignments that have a AutoTest configuration.
         * @param arg.hasHandinRequirements Get only assignments that have hand-in requirements.
         * @param arg.divisionParentId Only return assignments matching the given division parent id.
         * @param arg.groupSetId Only return assignments that are linked to this group set id.
         * @param arg.q Only assignments matching this query will be returned.
         * @param arg.pageSize The size of a single page, maximum is 50.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns A response containing the assignments of the given course sorted by deadline of the assignment
         */
        getAssignments: async ({ courseId, hasRubric = undefined, hasAutoTest = undefined, hasHandinRequirements = undefined, divisionParentId = undefined, groupSetId = undefined, q = undefined, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/courses/${courseId}/assignments/`, getAssignmentsResponse.v, undefined, {
                has_rubric: hasRubric,
                has_auto_test: hasAutoTest,
                has_handin_requirements: hasHandinRequirements,
                division_parent_id: divisionParentId,
                group_set_id: groupSetId,
                q,
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Create or edit an enroll link.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course in which this link should enroll users.
         * @param arg.requestBody The body of the request.
         * @returns The created or edited link.
         */
        putEnrollLink: async ({ courseId, requestBody, }) => {
            const result = await requestParams(config, 'PUT', `/api/v1/courses/${courseId}/registration_links/`, putEnrollLinkResponse.v, JSON.stringify(PutEnrollLinkCourseData.encode(requestBody)));
            return result;
        },
        /**
         * Get the registration links for the given course.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The course id for which to get the registration links.
         * @param arg.pageSize The size of a single page, maximum is 50.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns An array of registration links.
         */
        getAllEnrollLinks: async ({ courseId, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/courses/${courseId}/registration_links/`, getAllEnrollLinksResponse.v, undefined, {
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Create a new course section.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course to create a section for.
         * @param arg.requestBody The body of the request.
         * @returns The new section.
         */
        createSection: async ({ courseId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/courses/${courseId}/sections/`, createSectionResponse.v, JSON.stringify(CreateSectionCourseData.encode(requestBody)));
            return result;
        },
        /**
         * Get all sections of this course.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course to get the sections for.
         * @param arg.q Only find courses sections with a name matching this search query.
         * @param arg.pageSize The size of a single page, maximum is 50.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns A list of all sections connected to this course.
         */
        getSections: async ({ courseId, q = undefined, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/courses/${courseId}/sections/`, getSectionsResponse.v, undefined, {
                q,
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Update the price of the given course.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course for which you want to update the price.
         * @returns The created or updated price.
         */
        deletePrice: async ({ courseId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/courses/${courseId}/price`, deletePriceResponse.v, undefined);
            return result;
        },
        /**
         * Update the price of the given course.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course for which you want to update the price.
         * @param arg.requestBody The body of the request.
         * @returns The created or updated price.
         */
        putPrice: async ({ courseId, requestBody, }) => {
            const result = await requestParams(config, 'PUT', `/api/v1/courses/${courseId}/price`, putPriceResponse.v, JSON.stringify(PutPriceCourseData.encode(requestBody)));
            return result;
        },
        /**
         * Delete the `CourseSnippet` with the given id.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course in which the snippet is located.
         * @param arg.snippetId The id of the snippet
         * @returns An empty response with return code 204
         */
        deleteSnippet: async ({ courseId, snippetId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/courses/${courseId}/snippets/${snippetId}`, deleteSnippetResponse.v, undefined);
            return result;
        },
        /**
         * Modify the `CourseSnippet` with the given id.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course in which the course snippet is saved.
         * @param arg.snippetId The id of the snippet to change.
         * @param arg.requestBody The body of the request.
         * @returns An empty response with return code 204.
         */
        patchSnippet: async ({ courseId, snippetId, requestBody, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/courses/${courseId}/snippets/${snippetId}`, patchSnippetResponse.v, JSON.stringify(PatchSnippetCourseData.encode(requestBody)));
            return result;
        },
        /**
         * Delete the given registration link.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course to which the registration link is connected.
         * @param arg.linkId The id of the registration link.
         * @returns Nothing.
         */
        deleteEnrollLink: async ({ courseId, linkId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/courses/${courseId}/registration_links/${linkId}`, deleteEnrollLinkResponse.v, undefined);
            return result;
        },
        /**
         * Get a registration link.
         *
         * This route can be used without logging in, i.e. you don't have to be enrolled in the course to use this route. This route will not work for expired registration links.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course to which the registration link is connected.
         * @param arg.linkId The id of the registration link.
         * @returns The specified registration link.
         */
        getRegistrationLink: async ({ courseId, linkId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/courses/${courseId}/registration_links/${linkId}`, getRegistrationLinkResponse.v, undefined);
            return result;
        },
        /**
         * Remove a `CourseRole` from the given `Course`.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course
         * @param arg.roleId The id of the role you want to delete
         * @returns An empty response with return code 204
         */
        deleteRole: async ({ courseId, roleId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/courses/${courseId}/roles/${roleId}`, deleteRoleResponse.v, undefined);
            return result;
        },
        /**
         * Get a list of all course roles in a given course.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course to get the roles for.
         * @param arg.roleId The id of the role to get.
         * @returns The requested role.
         */
        getCourseRole: async ({ courseId, roleId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/courses/${courseId}/roles/${roleId}`, getCourseRoleResponse.v, undefined);
            return result;
        },
        /**
         * Update the `Permission` of a given `CourseRole` in the given `Course`.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course.
         * @param arg.roleId The id of the course role.
         * @param arg.requestBody The body of the request.
         * @returns An empty response with return code 204.
         */
        patchRole: async ({ courseId, roleId, requestBody, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/courses/${courseId}/roles/${roleId}`, patchRoleResponse.v, JSON.stringify(PatchRoleCourseData.encode(requestBody)));
            return result;
        },
        /**
         * Delete a user from a course.
         *
         * This does not delete the user's submissions within the course.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course to remove the user from.
         * @param arg.userId The id of the user to remove from the course.
         * @returns Nothing.
         */
        deleteUser: async ({ courseId, userId, }) => {
            const result = await requestParams(config, 'DELETE', `/api/v1/courses/${courseId}/users/${userId}`, deleteUserResponse.v, undefined);
            return result;
        },
        /**
         * Get all users and their role in a course.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course
         * @param arg.q Only retrieve users whose name or username matches this value. This will change the output to a list of users.
         * @param arg.pageSize The size of a single page, maximum is 50.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns All users in this course and their role.
         */
        getAllUsers: async ({ courseId, q = undefined, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/courses/${courseId}/enrollments/`, getAllUsersResponse.v, undefined, {
                q,
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Set the `CourseRole` of a user in the given course.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course in which you want to enroll a new user, or change the role of an existing user.
         * @param arg.requestBody The body of the request.
         * @returns The response will contain the JSON serialized user and course role.
         */
        changeUserRole: async ({ courseId, requestBody, }) => {
            const result = await requestParams(config, 'PUT', `/api/v1/courses/${courseId}/enrollments/`, changeUserRoleResponse.v, JSON.stringify(ChangeUserRoleCourseData.encode(requestBody)));
            return result;
        },
        /**
         * Get a course by id.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course
         * @returns A response containing the JSON serialized course
         */
        get: async ({ courseId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/courses/${courseId}`, getResponse.v, undefined);
            return result;
        },
        /**
         * Update the given course with new values.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course you want to update.
         * @param arg.requestBody The body of the request.
         * @returns The updated course, in extended format.
         */
        patch: async ({ courseId, requestBody, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/courses/${courseId}`, patchResponse.v, JSON.stringify(PatchCourseData.encode(requestBody)));
            return result;
        },
        /**
         * Get all snippets of the given course.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course from which you want to get the snippets.
         * @param arg.pageSize The size of a single page, maximum is 50.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns An array containing all snippets for the given course.
         */
        getSnippets: async ({ courseId, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/courses/${courseId}/snippets/`, getSnippetsResponse.v, undefined, {
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Get user statistics of a specific course.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course for which you want to get the statistics
         * @returns A response containing the course management statistics
         */
        getStatistics: async ({ courseId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/courses/${courseId}/statistics`, getStatisticsResponse.v, undefined);
            return result;
        },
        /**
         * Get all the authorization of the currently logged in user in this course.
         *
         * This will return the permission as if you have already paid, even if this is not the case. We will also not check any restrictions of the current session.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course of which the permissions should be retrieved.
         * @returns A mapping between the permission name and a boolean indicating if the currently logged in user has this permission.
         */
        getAuthorization: async ({ courseId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/courses/${courseId}/authorization`, getAuthorizationResponse.v, undefined);
            return result;
        },
        /**
         * Get all submissions by the given user in this course.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course from which you want to get the submissions.
         * @param arg.userId The id of the user of which you want to get the submissions.
         * @param arg.pageSize The size of a single page, maximum is 50.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns A paginated list of the submissions by the user in this course.
         */
        getSubmissionsByUser: async ({ courseId, userId, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/courses/${courseId}/users/${userId}/submissions/`, getSubmissionsByUserResponse.v, undefined, {
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Copy a course into another course.
         *
         * @param arg The arguments to the function.
         * @param arg.intoCourseId The course you want to import into.
         * @param arg.requestBody The body of the request.
         * @returns The updated course, so the course of which the id was passed in the url.
         */
        importInto: async ({ intoCourseId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/courses/${intoCourseId}/copy`, importIntoResponse.v, JSON.stringify(ImportIntoCourseData.encode(requestBody)));
            return result;
        },
        /**
         * Import snippets from another course into this course.
         *
         * @param arg The arguments to the function.
         * @param arg.intoCourseId The course you want to import snippets into.
         * @param arg.requestBody The body of the request.
         * @returns Nothing.
         */
        importSnippetsInto: async ({ intoCourseId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/courses/${intoCourseId}/snippets/import`, importSnippetsIntoResponse.v, JSON.stringify(ImportSnippetsIntoCourseData.encode(requestBody)));
            return result;
        },
        /**
         * Join a course as the currently logged in user using a registration link.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course in which you want to enroll.
         * @param arg.linkId The id of the link you want to use to enroll.
         * @returns Nothing.
         */
        joinAsLoggedInUser: async ({ courseId, linkId, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/courses/${courseId}/registration_links/${linkId}/join`, joinAsLoggedInUserResponse.v, undefined);
            return result;
        },
        /**
         * Register as a new user, and directly enroll in a course.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course to which the registration link is connected.
         * @param arg.linkId The id of the registration link.
         * @param arg.requestBody The body of the request.
         * @returns The access token that the created user can use to log in.
         */
        registerUserWithLink: async ({ courseId, linkId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/courses/${courseId}/registration_links/${linkId}/user`, registerUserWithLinkResponse.v, JSON.stringify(RegisterUserWithLinkCourseData.encode(requestBody)));
            return result;
        },
        /**
         * Sent the authors in this course an email.
         *
         * @param arg The arguments to the function.
         * @param arg.courseId The id of the course in which you want to send the emails.
         * @param arg.requestBody The body of the request.
         * @returns A task result that will send these emails.
         */
        emailUsers: async ({ courseId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/courses/${courseId}/email`, emailUsersResponse.v, JSON.stringify(EmailUsersCourseData.encode(requestBody)));
            return result;
        },
    });
}
